import { createRoute } from "@tanstack/react-router";
import { Lock } from "lucide-react";
import { accountRoute } from "./account-page";

export const accountSecurityRoute = createRoute({
  getParentRoute: () => accountRoute,
  path: "security",
  component: AccountSecurityPage
});

/**
 * Password/Security settings page component
 *
 * Features:
 * - Semantic HTML structure
 * - Accessible headings hierarchy
 * - Screen reader friendly
 * - Responsive layout
 */
function AccountSecurityPage() {
  return (
    <div>
      {/* Page Header */}
      <div className="border-border border-b p-6">
        <h2
          className="text-xl font-semibold text-gray-900 dark:text-white"
          id="password-heading"
        >
          Password
        </h2>
        <p
          className="mt-1 text-sm text-gray-600 dark:text-gray-400"
          id="password-description"
        >
          Manage your password and security settings
        </p>
      </div>

      {/* Content */}
      <div className="p-6">
        <section
          aria-labelledby="password-heading"
          aria-describedby="password-description"
        >
          <div
            className="flex min-h-[300px] flex-col items-center justify-center rounded-lg border border-dashed border-gray-300 dark:border-gray-700"
            role="status"
            aria-live="polite"
          >
            <Lock className="mb-4 h-12 w-12 text-gray-400" aria-hidden="true" />
            <p className="text-lg font-medium text-gray-900 dark:text-white">
              Password settings
            </p>
            <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
              Password change functionality coming soon...
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}
